import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Card,
  CardContent,
  DialogActions,
  TextField,
  Typography,
  Box,
  IconButton,
  Paper,
} from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import { printProductLabels } from "../../../utils/productLabelPrint";

const ProductLabel = ({
  open,
  setOpen,
  ean,
  name,
  sku,
  isMultipack = false,
  multipackProducts = [],
}) => {
  const [quantity, setQuantity] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    if (open) {
      setQuantity("");
      setIsPrinting(false);
    }
  }, [open]);

  const handleClose = () => {
    if (!isPrinting) {
      setOpen(false);
    }
  };

  const handlePrint = async () => {
    try {
      setIsPrinting(true);

      let labels = [];

      if (isMultipack) {
        multipackProducts.forEach((product) => {
          for (let i = 0; i < parseInt(quantity, 10); i++) {
            labels.push({
              sku: product.sku_id,
              ean: product.ean_id,
              name: product.name,
              isMultipack: true,
            });
          }
        });
      } else {
        for (let i = 0; i < parseInt(quantity, 10); i++) {
          labels.push({
            sku,
            ean,
            name,
            isMultipack: false,
          });
        }
      }

      await printProductLabels(labels);

      setIsPrinting(false);
      handleClose();
    } catch (error) {
      console.error("Error during print process:", error);
      setIsPrinting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          pb: 1,
        }}
      >
        <LocalOfferIcon sx={{ fontSize: 22 }} />
        Imprimir Etiquetas
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Configure la cantidad de etiquetas a imprimir
        </Typography>

        <Card variant="outlined">
          <CardContent>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                bgcolor: "grey.50",
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                {name}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    paddingTop: 0.5,
                  }}
                  variant="subtitle2"
                >
                  EAN:
                </Typography>
                <Box
                  component="code"
                  sx={{
                    bgcolor: "grey.100",
                    px: 1,
                    py: 0.5,
                    borderRadius: 1,
                    fontSize: "0.875rem",
                  }}
                >
                  {ean}
                </Box>
              </Box>
            </Paper>

            <TextField
              label="Cantidad de etiquetas"
              value={quantity}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setQuantity(value === "" ? "" : parseInt(value, 10));
                }
              }}
              fullWidth
              margin="normal"
              InputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </CardContent>
        </Card>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          onClick={handleClose}
          color="error"
          variant="outlined"
          disabled={isPrinting}
        >
          Cancelar
        </Button>
        <Button
          onClick={handlePrint}
          variant="contained"
          color="primary"
          disabled={!quantity || quantity < 1 || isPrinting}
          startIcon={<PrintIcon />}
        >
          {isPrinting ? "Imprimiendo..." : "Imprimir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductLabel;
